export default "__VITE_ASSET__116bd7fc__"